import './App.css';
import { AuthContext } from './components/Context';
import DefaultLayout from './components/layout/DefaultLayout';
import AuthLayout from './components/layout/AuthLayout';
import { useContext } from 'react';


const App = ()  => {

  const user = sessionStorage.getItem('participant_mobile');
  
  return !user ? <AuthLayout /> : <DefaultLayout/>;
}

export default App;
